import React, { useMemo } from "react";
import {
  Flex,
  Table,
  Checkbox,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Icon,
  Box,
} from "@chakra-ui/react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";

import { FcRedo, FcTemplate } from "react-icons/fc";
import { MdDeleteForever } from "react-icons/md";

function TableComponent(props) {
  const { columnsData, tableData, tableName, viewClick } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize }, // Current page index and page size
  } = tableInstance;

  const pageCount = Math.ceil(data.length / pageSize); // Calculate the number of pages

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
      p={4}
    >
      <Table {...getTableProps()} variant="simple" color="gray.500">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
              <Th pe="10px" borderColor={borderColor}>
                <Flex
                  justify="space between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  View
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor}>
                <Flex
                  justify="space between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  Delete
                </Flex>
              </Th>
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className="bg-color-text-2 border-color-text border-opacity-30 border-b"
        >
          {page.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <Td
                    {...cell.getCellProps()}
                    className="px-6 py-4 w-4/5"
                    color="black"
                  >
                    <div className="whitespace-nowrap overflow-hidden text-ellipsis">
                      {cell.render("Cell")}
                    </div>
                  </Td>
                ))}
                <Td color="red">
                  <Icon
                    onClick={() => {
                      viewClick(row);
                    }}
                    as={FcTemplate}
                    w="20px"
                    h="20px"
                  />
                </Td>
                <Td color="red">
                  <Icon as={MdDeleteForever} w="20px" h="20px" />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Box className="pagination" mt={3}>
        {pageIndex === 0 ? (
          <Icon
            as={FcRedo}
            w="30px"
            h="30px"
            opacity="40%"
            transform="rotate(180deg)"
            mr={5}
          />
        ) : (
          <Icon
            onClick={() => tableInstance.previousPage()}
            as={FcRedo}
            w="30px"
            h="30px"
            transform="rotate(180deg)"
            mr={5}
          />
        )}

        <span>
          {/* Page{" "} */}
          <strong>
            {pageIndex + 1} of {pageCount}
          </strong>{" "}
        </span>
        {pageIndex >= pageCount - 1 ? (
          <Icon as={FcRedo} w="30px" h="30px" mr={5} opacity="40%" ml={5} />
        ) : (
          <Icon
            onClick={() => tableInstance.nextPage()}
            as={FcRedo}
            w="30px"
            h="30px"
            ml={5}
          />
        )}
      </Box>
    </Card>
  );
}

export default TableComponent;
